export default [
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/finance/FinanceMain.vue'),
    meta: {
      pageTitle: 'Финансы',
      breadcrumb: [
        { text: 'Финансы', active: true },
      ],
      resource: 'finance',
      action: 'view',
    },
  },
  {
    path: '/finance/weeks/:id',
    name: 'finance-week-detail',
    component: () => import('@/views/finance/FinanceWeekDetail.vue'),
    meta: {
      pageTitle: 'Детали недели',
      breadcrumb: [
        { text: 'Финансы', to: { name: 'finance', query: { tab: 'weeks' } } },
        { text: 'Детали недели', active: true },
      ],
      navActiveLink: 'finance',
      resource: 'finance',
      action: 'view',
    },
  },
]
